<template>
  <div class="changes-since-last-visit-line__container sf-below-2">
    <div class="changes-since-last-visit-line__half-border"></div>
    <p class="changes-since-last-visit-line__text sf-font-xs sf-font-medium">
      {{ I18n.t('audit.changes_since') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.changes-since-last-visit-line {
  &__container {
    clear: both;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -8px;
  }

  &__half-border {
    width: 100%;
    height: 29px;
    padding: 0 8px 12px;
    flex: 1;
    border: 1px solid -color('danger');
    border-top-style: none;
  }

  &__text {
    margin: -9px 0 0;
    padding: 0 8px;
    color: -color('danger');
    background-color: -color('white');
    text-transform: uppercase;
  }
}
</style>
